var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancelBlack2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cancel",
    transform: "translate(-6223.495 -889.411)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_307",
    transform: "translate(1.165 1.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_66",
    d: "M6250.1,917.5c-0.4,0-0.7-0.1-1-0.4l-15.6-15.6c-0.6-0.6-0.6-1.4,0-2c0.6-0.6,1.4-0.6,2,0l15.6,15.6 c0.6,0.6,0.6,1.4,0,2C6250.9,917.3,6250.5,917.5,6250.1,917.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_67",
    d: "M6234.5,917.5c-0.4,0-0.7-0.1-1-0.4c-0.6-0.6-0.6-1.4,0-2l15.6-15.6c0.6-0.6,1.4-0.6,2,0 c0.6,0.6,0.6,1.4,0,2l-15.6,15.6C6235.3,917.3,6234.9,917.5,6234.5,917.5z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_52",
    d: "M6243.5,889.9c10.8,0,19.5,8.7,19.5,19.5c0,10.8-8.7,19.5-19.5,19.5c-5.2,0-10.1-2.1-13.8-5.7 c-7.6-7.6-7.6-19.9,0-27.6c0,0,0,0,0,0C6233.4,892,6238.3,889.9,6243.5,889.9z M6243.5,926.1c9.2,0,16.7-7.5,16.7-16.7 s-7.5-16.7-16.7-16.7c-9.2,0-16.7,7.5-16.7,16.7C6226.9,918.6,6234.3,926.1,6243.5,926.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelBlack2);
export default __webpack_public_path__ + "static/media/cancelBlack2.611632b98c505c4ed0155197b7687876.svg";
export { ForwardRef as ReactComponent };